export const BLOB_SERVICE = 'https://withjoy.com/media/paper';
export const PPI = 72;
